// https://vuex.vuejs.org/en/getters.html

export default {
  prescriptions(state) {
    return state.prescriptions;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
